import React, { useEffect, useState } from 'react'
import {
    UserOutlined,
    CheckCircleOutlined,
    CloseCircleOutlined,
    SyncOutlined,
    HourglassOutlined,
    CalendarOutlined,
    CheckOutlined
} from '@ant-design/icons';
import { Card, Skeleton, Space, Table, Tag } from 'antd';
import PageTitle from '../../Utility/PageTitle';
import RecentApplications from './RecentApplications';
import { useFetch } from '../../../services/ApiService';
import { HiOutlineCheckBadge } from 'react-icons/hi2';
import { AiOutlineCheckSquare } from 'react-icons/ai';

function Dashboard() {
    const [countData, setCountData] = useState([])
    const [loading, setLoading] = useState(true);
    const { fetchApi } = useFetch();

    const getCountData = async () => {
        setLoading(true);
        await fetchApi('/api/application_summary', 'GET').then(res => {
            let countValues = {};
            res.map(item => {
                countValues[item.status] = item.sum
            });
            setCountData(countValues)
        }).catch(err => {
            console.log(err);
        })
        setLoading(false);
    }
    useEffect(() => {
        getCountData()
    }, [])

    return (
        <>
            <PageTitle title="Dashboard" />
            <div className="row"> 
                <div className="col-lg-4 col-sm-6">
                    <div className="card-box card-box-purple">
                        <div className="card-box-info">
                            <div className="card-box-label">Total Applications</div>
                            {
                                loading ?
                                    <Skeleton.Input active /> :
                                    <div className="card-box-data">{countData.all ? countData.all : '0'}</div>
                            }
                        </div>
                        <span className='card-box-icon'>
                            <UserOutlined />
                        </span>
                    </div>
                </div>

                <div className="col-lg-4 col-sm-6">
                    <div className="card-box card-box-cyan">
                        <div className="card-box-info">
                            <div className="card-box-label">Approved Applications</div>
                            {
                                loading ?
                                    <Skeleton.Input active /> :
                                    <div className="card-box-data">{countData.approved ? countData.approved : '0'}</div>
                            }
                        </div>

                        <div className='card-box-icon'>
                            <CheckCircleOutlined />
                        </div>
                    </div>
                </div>

                <div className="col-lg-4 col-sm-6">
                    <div className="card-box ">
                        <div className="card-box-info">
                            <div className="card-box-label">Rejected Applications</div>
                            {
                                loading ?
                                    <Skeleton.Input active /> :
                                    <div className="card-box-data">{countData.rejected ? countData.rejected : '0'}</div>
                            }
                        </div>

                        <div className='card-box-icon'>
                            <CloseCircleOutlined />
                        </div>
                    </div>
                </div>

                <div className="col-lg-4 col-sm-6">
                    <div className="card-box card-box-grey">
                        <div className="card-box-info">
                            <div className="card-box-label">Pending Applications</div>
                            {
                                loading ?
                                    <Skeleton.Input active /> :
                                    <div className="card-box-data">{countData.pending ? countData.pending : '0'}</div>
                            }
                        </div>

                        <span className='card-box-icon'>
                            <HourglassOutlined />
                        </span>
                    </div>
                </div>
                <div className="col-lg-4 col-sm-6">
                    <div className="card-box card-box-blue">
                        <div className="card-box-info">
                            <div className="card-box-label">Scheduled Applications</div>
                            {
                                loading ?
                                    <Skeleton.Input active /> :
                                    <div className="card-box-data">{countData.scheduled ? countData.scheduled : '0'}</div>
                            }
                        </div>

                        <span className='card-box-icon'>
                            <CalendarOutlined />
                        </span>
                    </div>
                </div>
                <div className="col-lg-4 col-sm-6">
                    <div className="card-box card-box-green">
                        <div className="card-box-info">
                            <div className="card-box-label">Completed Applications</div>
                            {
                                loading ?
                                    <Skeleton.Input active /> :
                                    <div className="card-box-data">{countData.completed ? countData.completed : '0'}</div>
                            }
                        </div>

                        <span className='card-box-icon'>
                            <CheckOutlined />
                        </span>
                    </div>
                </div>
                <div className="col-lg-4 col-sm-6">
                    <div className="card-box card-box-darkgreen">
                        <div className="card-box-info">
                            <div className="card-box-label">Confirmed Applications</div>
                            {
                                loading ?
                                    <Skeleton.Input active /> :
                                    <div className="card-box-data">{countData.confirmed ? countData.confirmed : '0'}</div>
                            }
                        </div>

                        <span className='card-box-icon'>
                            <AiOutlineCheckSquare />
                        </span>
                    </div>
                </div>
            </div>

            <RecentApplications />
        </>
    )
}

export default Dashboard